import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { S1Modal, S1ButtonType, S1UIService, S1ModalSizes } from '@app/s1';
import { IStazione } from '@app/shared/models/stazione';
import { StazioneService } from '@app/shared/services/stazione.service';

@Component({
  selector: 'ser-stazione',
  templateUrl: './stazione.component.html',
  styleUrl: './stazione.component.scss'
})
export class StazioneComponent {

  @Output() updated = new EventEmitter<boolean>();
  @Output() created = new EventEmitter<string>();

  @ViewChild('modal') modal: S1Modal;

  s1ButtonType = S1ButtonType;

  stazioneForm: UntypedFormGroup;
  stazione: IStazione;
  isNew: boolean = true;

  constructor(private formBuilder: UntypedFormBuilder, private stazioneService: StazioneService, private ui: S1UIService) {

    this.stazioneForm = this.formBuilder.group({
      'codice': [Validators.required, null],
      'descrizione': [Validators.required, null],
      'latitudine': [Validators.required, null],
      'longitudine': [Validators.required, null],
      'inGestione': [Validators.required, false],
      'wallet': [Validators.required, null],
      'fondo': [Validators.required, null],
      'isElevazioneRuolo': [Validators.required, false],
    })

    this.stazioneForm.controls.inGestione.valueChanges.subscribe(newValue => {

      if (newValue) {
        this.stazioneForm.controls.wallet.addValidators(Validators.required);
      } else {
        this.stazioneForm.controls.wallet.clearValidators();
      }

      this.stazioneForm.controls.wallet.updateValueAndValidity();

    })

  }

  ngOnInit(): void { }

  open(idStazione?: string) {

    this.isNew = !idStazione;

    this.stazioneForm.reset();

    if (!this.isNew) {
      this.getDetail(idStazione);
    }

    this.modal.open(S1ModalSizes.XL);

  }

  close() {
    this.modal.close();
  }

  getDetail(idStazione: string) {

    this.stazioneService.dettaglio(idStazione).subscribe(stazione => {
      this.stazione = stazione;
      this.stazioneForm.patchValue({
        'codice': this.stazione?.codice,
        'descrizione': this.stazione?.descrizione,
        'latitudine': this.stazione?.latitudine,
        'longitudine': this.stazione?.longitudine,
        'inGestione': this.stazione?.inGestione,
        'wallet': this.stazione?.wallet,
        'fondo':  this.stazione.fondo,
        'isElevazioneRuolo': this.stazione?.isElevazioneRuolo
      })
    })

  }

  create() {

    const newStazione: IStazione = {
      "codice": this.stazioneForm.controls.codice.value,
      "descrizione": this.stazioneForm.controls.descrizione.value,
      "latitudine": this.stazioneForm.controls.latitudine.value,
      "longitudine": this.stazioneForm.controls.longitudine.value,
      'inGestione': this.stazioneForm?.controls.inGestione.value ?? false,
      'wallet': this.stazioneForm?.controls.wallet.value ?? 0,
      'fondo':  this.stazioneForm?.controls.fondo.value ?? 0,
      'isElevazioneRuolo': this.stazioneForm?.controls.isElevazioneRuolo.value ?? false
    }

    this.stazioneService.crea(newStazione).subscribe(stazione => {
      this.ui.showSuccessToast("stazioni.messages.created");
      this.close();
      this.created.emit(stazione);
      this.stazioneForm.reset();
    })

  }

  update() {

    const stazioneToUpdate: IStazione = {
      "id": this.stazione.id,
      "codice": this.stazioneForm.controls.codice.value,
      "descrizione": this.stazioneForm.controls.descrizione.value,
      "latitudine": this.stazioneForm.controls.latitudine.value,
      "longitudine": this.stazioneForm.controls.longitudine.value,
      'inGestione': this.stazioneForm?.controls.inGestione.value ?? false,
      'wallet': this.stazioneForm?.controls.wallet.value ?? 0,
      'fondo':  this.stazioneForm?.controls.fondo.value ?? 0,
      'isElevazioneRuolo': this.stazioneForm?.controls.isElevazioneRuolo.value ?? false
    }

    this.stazioneService.modifica(stazioneToUpdate).subscribe(success => {

      if (success) {
        this.ui.showSuccessToast("stazioni.messages.updated");
        this.updated.emit(success);
        this.stazioneForm.reset();
        this.close();
      }
      
    })

  }

}
